import ORGANIZATION_TYPES from '../enums/OrganizationTypes';

const getAvailableOrganizationTypes = providerType => {
    switch (providerType) {
        case ORGANIZATION_TYPES.MERCHANT.name:
            return null;
        case ORGANIZATION_TYPES.WHITE_LABEL.name:
            return [ORGANIZATION_TYPES.MERCHANT];
        default:
            throw new Error(`Unknown provider type ${providerType}`);
    }
};

const getOrganizationTypeOptions = (providerType) => getAvailableOrganizationTypes(providerType)
    .map(type => ({
        name: type.name,
        value: type.name
    }));

export { getAvailableOrganizationTypes, getOrganizationTypeOptions };